<template>
  <CSidebar class="pretest-sidebar" position="fixed" :visible="true">
    <div>
      <div class="brand">
        <CSidebarBrand
          style="cursor: pointer"
          @click="$router.push('/analysis-report/report-enterprise-list')"
        >
          <img src="@/assets/images/logo-black.svg" />
        </CSidebarBrand>
      </div>
      <div class="que-btn-group">
        <button
          v-if="
            (($route.name === 'editClassification' ||
              $route.name === 'EditPart') &&
              $route.params.part) ||
            $route.params.id
          "
          class="border-0 btn btn-primary edit-sidebar-btn position-relative"
          @click="$router.push(`/edit-classification/${questionnaireId}`)"
        >
          <img
            class="position-absolute"
            src="@/assets/icons/edit-blue.svg"
            alt=""
          />
          <span>編輯問卷信息</span>
        </button>

        <button
          v-for="item in questionnaireOptions"
          :key="item"
          @click="$router.push(`/${questionnaireId}/${item.id}`)"
          :style="
            +$route.params.part === item.id
              ? 'background: #D1E5EF'
              : 'background: #f3f8fb'
          "
          class="border-0 btn mt-2 text-dark edit-options-btn position-relative d-flex justify-content-between align-items-center"
        >
          <span> {{ item.title }}</span>
          <img
            v-if="item.is_display === $defines.Part_Is_Display_No"
            class="lock-img"
            src="@/assets/icons/lock.svg"
            alt="lock"
          />
        </button>
      </div>
    </div>
    <div>
      <div class="content-wrapper">
        <p class="fw-bold">查看其他功能</p>
        <router-link
          :to="link.path"
          class="link"
          v-for="link in links"
          :key="link.title"
        >
          <img
            class="me-3"
            :src="require(`@/assets/icons/${link.img}.svg`)"
            alt=""
          />
          {{ link.title }}
        </router-link>
      </div>

      <div class="user">
        <span class="fw-bold">{{ username }}</span>
        <button
          @click="logout"
          class="btn border-0 p-0 d-flex align-items-center"
        >
          <img class="me-2" src="@/assets/icons/logout.svg" alt="" />
          <span>登出</span>
        </button>
      </div>
    </div>
  </CSidebar>
  <MsgBox
    :show="showMsgBox"
    :errorCode="errorCode"
    :errorMsg="errorMsg"
    @close="showMsgBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import { onMounted } from '@vue/runtime-core'
import MsgBox from '@/components/MsgBox.vue'
import router from '@/router'

export default {
  props: {
    questionnaireOptions: {
      type: Array,
      default: () => [],
    },
    questionnaireId: {
      type: [String, Number],
      default: null,
    },
  },
  components: {
    MsgBox,
  },
  setup() {
    const { getUserInfo, signOut } = useInfo()
    const showMsgBox = ref(false)
    const username = ref('')
    const errorMsg = ref('')
    const errorCode = ref('')
    const links = ref([
      {
        title: '問卷列表',
        img: 'analysis',
        path: '/analysis-questionnaire',
      },
      {
        title: '用戶填答結果',
        img: 'analysis-report',
        path: '/analysis-report/report-enterprise-list',
      },
      {
        title: '用戶管理',
        img: 'user-management',
        path: '/user-management/user-enterprise-list',
      },
      {
        title: 'JYG ESG 企業健檢',
        img: 'reply',
        path: '/user-management/user-reply',
      },
    ])
    onMounted(async () => {
      const res = await getUserInfo()
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        username.value = res.ret.info.username
      }
    })

    const logout = async () => {
      await signOut()
      router.push('/sign')
    }
    return {
      links,
      showMsgBox,
      errorCode,
      errorMsg,
      username,
      logout,
    }
  },
}
</script>
<style lang="scss" scoped>
:global(.pretest-sidebar) {
  --cui-sidebar-brand-bg: none;
  --cui-sidebar-color: #4d4d4d;
  border-radius: 0 20px 20px 0;
  border: 1px solid #eff0f6;
  background: #ffffff;
  filter: drop-shadow(0px 5px 20px rgba(0, 0, 0, 0.05));
  display: flex;
  justify-content: space-between;
}
.brand {
  padding: 24px 0;
  img {
    width: 120px;
  }
}
.content-wrapper {
  padding: 0 25px;
}
.link {
  display: block;
  margin-bottom: 16px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.154px;
  color: #4d4d4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  height: 48px;
  display: flex;
  align-items: center;
  padding: 0 19px;
  border-radius: 10px;
}
.user {
  height: 143px;
  border-top: 1px solid #e5e5e5;
  margin: 0 10px;
  padding: 30px 28px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.edit-sidebar-btn {
  font-size: 14px;
  width: 192px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f8fb;
  color: #177baf;
  border-radius: 4px;
  margin: 0 25px;
  img {
    left: 16px;
  }
}
.edit-options-btn {
  font-size: 14px;
  width: 192px;
  height: 48px;
  display: flex;
  justify-content: left;
  align-items: center;
  color: #177baf;
  border-radius: 4px;
  margin: 0 25px;
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.edit-classification-btn {
  font-size: 14px;
  width: 192px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f8fb;
  color: #4d4d4d;
  border-radius: 4px;
  margin: 0 25px;
  img {
    right: 16px;
  }
}
.que-btn-group {
  height: 400px;
  overflow: scroll;
  z-index: 2;
  padding-top: 10px;
}
::-webkit-scrollbar {
  display: none;
}
.lock-img {
  width: 20px;
  margin-left: 5px;
}
</style>
